export const TwitterRoles = {
    SHARE_RIDDLE_SUCCESS: 'SHARE_RIDDLE_SUCCESS',
    RETWEET_RIDDLE: 'RETWEET_RIDDLE'
}